<template>
  <div>
    <!-- Add Supervisor Form -->
    <div class="main-box two-column">
      <employee-sidebar :employeeData="employee"></employee-sidebar>
      <div class="emplyee-info-wrp">
        <div class="assign-form" v-if="showAssignForm">
          <h2 class="text-capitalize">Add {{ role }}</h2>
          <div class="row">
            <div class="col-md-6">
              <form @submit.prevent="addSubordinate">
                <div class="form-group">
                  <label>Name:</label>
                  <!-- Search input with autocomplete -->
                  <input class="form-control" v-model="searchTerm" @input="filterEmployees" placeholder="Search for Employee..." required />
                  <ul v-if="filteredEmployees.length" class="suggestion-list">
                    <li v-for="employee in filteredEmployees" :key="employee.id" @click="selectEmployee(employee)">
                      {{ employee.name }}
                    </li>
                  </ul>

                </div>
                <input type="hidden" v-model="role" >
                <div class="form-group">
                  <label>Reporting Method:</label>
                  <select class="form-control" v-model="reportingMethod" required>
                    <option value="Direct">Direct</option>
                    <option value="Indirect">Indirect</option>
                    <option value="Other">Other</option>
                  </select>
                </div>
                <button class="btn btn-primary" type="submit">Save</button>
                <button class="btn btn-default" @click="cancelForm">Cancel</button>
              </form>
            </div>
          </div>
        </div>


        <!-- Supervisors Section -->
        <div class="supervisor-block mt-5 border p-10">
          <button class="btn btn-primary" v-if="!showAssignForm && isPermissionAccess" type="button" @click="toggleAssignSupervisorForm">Add Supervisor</button>
          <h2>Assigned Supervisors</h2>
          <div class="row" v-if="supervisors.length">
            <div class="col-lg-12 col-xl-12 mb-20 mb-lg-0">
              <div class="table-scroll salary-table">
                <table class="table" >
                  <thead class="table-head">
                  <tr>
                    <th>Name</th>
                    <th>Reporting Method</th>
                    <th>Actions</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="supervisor in supervisors" :key="supervisor.id">
                    <td>{{ supervisor.name }}</td>
                    <td>{{ supervisor.reporting_method || 'N/A' }}</td>
                    <td><button v-if="isPermissionAccess" @click="removeSubordinate(supervisor.id)">Remove</button></td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <!-- Subordinates Section -->
        <div class="subordinate-block mt-5 border p-10">
          <button class="btn btn-primary"  type="button" v-if="!showAssignForm && isPermissionAccess" @click="toggleAssignSubordinateForm">Add Subordinate</button>
          <h2>Assigned Subordinates</h2>
          <div class="row" v-if="subordinates.length">
            <div class="col-lg-12 col-xl-12 mb-20 mb-lg-0">
              <div class="table-scroll salary-table">
                <table class="table" >
                  <thead class="table-head">
                  <tr>
                    <th>Name</th>
                    <th>Reporting Method</th>
                    <th>Actions</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="subordinate in subordinates" :key="subordinate.id">
                    <td>{{ subordinate.name }}</td>
                    <td>{{ subordinate.reporting_method || 'N/A' }}</td>
                    <td><button  v-if="isPermissionAccess" @click="removeSubordinate(subordinate.id)">Remove</button></td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>




<script>
import createEmployeeModal from "./createEmployeeModal";
import employeeSidebar from "./employeeSidebar";
import ClipLoader from "vue-spinner/src/ClipLoader";

export default {
  components: {
    createEmployeeModal,
    employeeSidebar,
    ClipLoader
  },
  data() {
    return {
      employee: this.$store.getters.getEmployeeProfileId,
      company_id: this.$store.getters.getSelectedCompany.id,
      user: this.$store.getters.getUser,
      newSubordinateId: '',
      role: '',
      reportingMethod: 'Direct',
      supervisors: [],
      subordinates: [],
      employees: [],
      filteredEmployees: [],
      searchTerm: '',
      showAssignForm: false,
      isPermissionAccess: false,
    };
  },
  methods: {
    toggleAssignSupervisorForm() {
      // Toggle the visibility of the Add Supervisor form
      this.role="supervisor";
      this.showAssignForm = !this.showAssignForm;
    },
    cancelForm() {
      // Hide the form when Cancel is clicked
      this.role='';
      this.showAssignForm = false;
    },
    toggleAssignSubordinateForm() {
      // Toggle the visibility of the Add Subordinate form
      this.role="subordinate";
      this.showAssignForm = !this.showAssignForm;
    },

    // Add subordinate
    async addSubordinate() {
      try {
        this.$axios({
          method: "POST",
          data: {
            supervisor_id: this.employee.id,
            role: this.role,
            subordinate_id: this.newSubordinateId,
            reporting_method: this.reportingMethod
          },
          url: this.$ReportToSupervisor + '/add-subordinate',
          headers: this.getAuthHeader(),
        }).then((res) => {
          if (res.data.status === 200) {
            this.fetchSupervisors();  // Refresh the supervisor list
            this.fetchSubordinates();  // Refresh the supervisor list
            alert(this.role.charAt(0).toUpperCase() + this.role.slice(1)+' Added Successfully');
            this.showAssignForm = false;
            this.role='';
            this.subordinate_id='';
            this.reporting_method='';
            this.searchTerm='';
          }
        });
      } catch (error) {
        console.error('Error adding subordinate:', error);
      }

    },

    // Remove subordinate
    async removeSubordinate(subordinateId) {

      try {
        const params = { company_id: this.company_id };
        const response = await this.$axios.get(this.$ReportToSupervisor + `/${this.employee.id}/remove/${subordinateId}`, {
          params: params,
          headers: this.getAuthHeader()
        });
        this.fetchSupervisors();  // Refresh the supervisor list
        this.fetchSubordinates();  // Refresh the supervisor list
        alert('Removed Successfully');
      } catch (error) {
        console.error('Error fetching supervisors:', error);
      }
    },

    // Fetch the supervisors
    async fetchSupervisors() {
      try {
        const params = { company_id: this.company_id,role:'supervisor' };
        const response = await this.$axios.get(this.$ReportToSupervisor + `/${this.employee.id}/supervisors`, {
          params: params,
          headers: this.getAuthHeader()
        });
        this.supervisors = response.data.result || [];
      } catch (error) {
        console.error('Error fetching supervisors:', error);
      }
    },

    async fetchSubordinates() {
      try {
        const params = { company_id: this.company_id,role:'subordinate' };
        const response = await this.$axios.get(this.$ReportToSupervisor + `/${this.employee.id}/subordinates`, {
          params: params,
          headers: this.getAuthHeader()
        });
        this.subordinates = response.data.result || [];
      } catch (error) {
        console.error('Error fetching subordinates:', error);
      }
    },
    // Fetch employees from the company
    async getCompanyEmployees() {
      try {
        const params = {employeeIds: this.user.id, company_id: this.company_id};
        const response = await this.$axios.get(this.$GetEmployeesWithOutSelect, {
          params: params,
          headers: this.getAuthHeader(),
        });
        this.employees = response.data.result; // Store the full list of employees
      } catch (error) {
        console.error('Error fetching employees:', error);
      }
    },

    // Filter employees based on search term
    filterEmployees() {
      if (this.searchTerm === '') {
        this.filteredEmployees = [];
      } else {
        this.filteredEmployees = this.employees.filter(employee => {
          return employee.name.toLowerCase().includes(this.searchTerm.toLowerCase());
        });
      }
    },

    // Select an employee from the list and set the subordinate ID
    selectEmployee(employee) {
      this.newSubordinateId = employee.id;
      this.searchTerm = employee.name;  // Optionally, set the search term to the employee's name
      this.filteredEmployees = [];  // Clear the suggestions after selection
    }
  },

  mounted() {
    this.getCompanyEmployees();
    this.fetchSubordinates();
    this.fetchSupervisors();
  },
  created() {
    this.isPermissionAccess=this.routeAndPageAccess(this.user);
  }
};
</script>
<style scoped>
.suggestion-list {
  position: absolute;
  background-color: white;
  border: 1px solid #ddd;
  max-height: 200px; /* Limit the height of the dropdown */
  overflow-y: auto; /* Scrollbar when content exceeds max-height */
  width: 100%;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1); /* Adding shadow to list */
  z-index: 999; /* Ensure it's on top of other elements */
  margin-top: 4px; /* Slight space between input and list */
  padding: 0;
  list-style-type: none;
}

.suggestion-list li {
  padding: 8px;
  font-size: 14px;
  cursor: pointer;
  border-bottom: 1px solid #f1f1f1;
}

.suggestion-list li:hover {
  background-color: #f1f1f1; /* Highlight the item on hover */
}
</style>


